<template>
  <section id="header-top-bar" class="header-top-bar">
    <div class="wrapper-header " :class="{ 'expand': isMenuCollapse }">
      <div class="row px-3">
     
        <div v-if="!routeSteps && !isMobile" class="col-sm-12 col-md-4 align-items-center route">
          <small class="btnheader d-inline float-left mt-2" @click="back()"><i
              class="icon-navigate_before nav "></i></small>
          <small class="btnheader d-inline float-left mt-2" @click="forward()"><i
              class="icon-navigate_next nav"></i></small>
          <small v-if="getCurrentRoute" class="ml-1 d-inline">{{ getCurrentRouteLabel || $t('lang.label.' + `${getCurrentRoute}`) }}</small>
          <small v-if="getChild" class="ml-1  d-inline">/ {{ getChild }}</small>
        </div>
        <div v-if="routeSteps && !isMobile" class="col-sm-12 col-md-4 d-flex align-items-center route">
          <router-link to="/campaigns" @mousedown.native="mousedown('/campaigns')">
            <button class="btnheader"><i class="icon-navigate_before nav "></i></button>
            <span class="ml-2">{{ $t('lang.label.backtoallcampaigns') }}</span>
          </router-link>
        </div>

        <div id="usermenu" class="" :class="isMobile ? 'w-100' : 'd-flex justify-content-end align-items-center  col-sm-12 col-md-8 '">

          <!-- biz dev button billing -->
          <!-- <div v-if="user.role_id == 4" class="mr-5">
            <div v-if="!isSubscriptionConnectPlusActive">
              <button class="btn btn-primary py-1 btn-md rounded-pill py-2" @click="goToUpgrade()">
                <small class="font-weight-bold px-2">{{ $t("lang.button.bizdevbutton") }}</small>
              </button>
            </div>
            <div v-else-if="false">
              <button class="btn btn-success py-1 btn-md rounded-pill py-2">
                <small class="font-weight-bold px-2">{{ $t("lang.button.bizdevbutton_active") }}</small>
              </button>
            </div>
          </div> -->

          <div class="mr-3" v-if="isBdrUser">
            <!-- button to search -->
            <button class="btn btn-primary py-1 btn-sm" @click="searchOpportunity()">
              <i class="icon-search"></i>
              Find opportunity
            </button>
          </div>

          <div class="mr-4" v-if="isBdrUser">
            <BookerStatsIcons @setBdrInfo=setBdrInfo($event) />
          </div>

          <!-- List icons of Stats -->
          <div class="ml-0 px-0" v-if="hasPermissions('superAdmin') && !isUserOperational">
            <Tooltip :text="'Sent emails'" :width="'130px'">
              <img class="py-0 my-0" src="@/assets/images/icon_sent-mail.png" alt="" srcset="" width="18px">
            </Tooltip>

            <span v-if="loadingStatsComplete && loadingData" class="mx-2 p-0">
              <Loadingcircle :paramloading="paramloading" />
            </span>

            <small class="ml-2 mr-3" v-if="loadingData && !loadingStatsComplete">
              {{ (statsHeaderBar.activity_by_date.sent) ? statsHeaderBar.activity_by_date.sent[0] : '0' }}
            </small>
            <span v-if="!loadingData" class="mx-2">__</span>

            <Tooltip :text="'Meetings / Sent Emails'" :width="'130px'">
              <img class="py-0 my-0" src="@/assets/images/icon_growth-chart.png" alt="" srcset="" width="18px">
            </Tooltip>

            <span v-if="loadingStatsComplete && loadingData" class="mx-2 p-0">
              <Loadingcircle :paramloading="paramloading" />
            </span>
            <small class="ml-2 mr-3" v-if="loadingData && !loadingStatsComplete">
              % {{ (statsHeaderBar.activity_by_date.conversion_rate) ?
                statsHeaderBar.activity_by_date.conversion_rate[0] : '0' }}
            </small>
            <!-- <span v-if="!loadingData" class="mx-2">__</span>

                            <Tooltip
                              :text="'Meetings'"
                              :width="'130px'"
                            >
                            <img class="py-0 my-0" src="@/assets/images/icon_agenda.png"   alt="" srcset="" width="18px">
                            </Tooltip>

                            <span v-if="loadingStatsComplete && loadingData" class="mx-2 p-0">
                                <Loadingcircle :paramloading="paramloading"  />
                              </span>
                            <small class="ml-2 mr-3" v-if="loadingData && !loadingStatsComplete">
                              {{ (statsHeaderBar.activity_by_date.meetings)  ? statsHeaderBar.activity_by_date.meetings[0] : '0' }}
                            </small>
                            <span v-if="!loadingData" class="mx-2">__</span> -->
            <!-- <Tooltip
                              :text="'Spent'"
                              :width="'130px'"
                            >
                              <img class="py-0 my-0" src="@/assets/images/icon_coin.png"   alt="" srcset="" width="18px">
                            </Tooltip>
                            <span v-if="loadingStatsComplete && loadingData" class="mx-2 p-0">
                                <Loadingcircle :paramloading="paramloading"  />
                              </span>
                            <small class="ml-2 mr-0" v-if="loadingData && !loadingStatsComplete">
                              {{ (statsHeaderBar.activity_by_date.money) ? parseFloat(statsHeaderBar.activity_by_date.money[0]).toFixed(2) : '0' }}
                            </small> -->
            <small v-if="!loadingStatsComplete" class="mx-3 icon-refresh cursor-pointer" @click="getDataStats"></small>

          </div>

          <!-- <router-link v-if="toastNotificationData.credits.left < 50 && permissionFront() && this.currentUser.is_agency == 0" class="px-3 py-2 ml-2 mr-2 badge"

                                :class="toastNotificationData.credits.left == 0 ? 'badge-secondary' : 'badge-primary'"

                                 to="/settings-account">{{toastNotificationData.credits.left}} Credits
                                 </router-link> -->


          <router-link class="btn-primary btn-sm px-3 py-2 mr-4 badge"
            v-if="currentUser.role_id == 2 && permissionFront() && currentUser.team_role_id != 2" to="/upgrade"><i
              class="icon icon-rocket"></i> {{ $t('lang.button.upgrade') }}
          </router-link>


          <ul class="d-flex d-flex justify-content-end">
            <li>
              <div class="d-flex justify-content-end align-items-center cursor-pointer" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <span v-if="currentUser.avatar == null || currentUser.avatar == '' || currentUser.avatar == undefined">
                  <img src="@/assets/images/emptyperson.png" class="rounded-circle border-color img-user" width="">
                </span>
                <span v-else><img :src="currentUser.avatar" class="rounded-circle border-color img-user"
                    width=""></span>
                <span class="nameuser ml-2">{{ currentUser.name }}</span>
                <i class="icon-expand_more ml-2 " v-if="permissionFront()"></i>
              </div>


              <div class="dropdown-menu" v-if="permissionFront()">

                <div class="p-2 btn-sm">
                  <router-link to="/settings-account" @mousedown.native="mousedown('/settings-account')">
                    <i class="icon-gear"></i>
                    <strong class="ml-2">{{ $t('lang.button.settings') }}</strong>
                  </router-link>
                </div>
                <div class="p-2 btn-sm">
                  <a class="" href="https://help.oliverlist.com/knowledge"><i class="icon-question"></i><strong
                      class=" ml-2">{{ $t('lang.button.help') }}</strong></a>
                </div>
                <div class="p-2 btn-sm">
                  <a class="" href="/login"><i class="icon-sign-out"></i><strong class=" ml-2">{{
                    $t('lang.button.logout')}}</strong></a>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="col-12 m-4" v-if="isBdrUser && showBDRSuspensionAlert">
          <div class="row">
            <div class="alert alert-danger" :key="'bdrInfo' + bdrInfo.meetings_rate"
              v-if="bdrInfo.meetings_rate < bdrMeetingsRateThreshold">
              {{ $t("lang.bdr.meetingsratelow", {
                meetings_rate: bdrInfo.meetings_rate, meetings_rate_threshold:
                  bdrMeetingsRateThreshold
              }) }}</div>
          </div>
        </div>

        <span v-if="info" class="px-2 mt-3 text-primary rounded"><i class="icon icon-warning"></i> {{ info }}</span>
      </div>
    </div>
  
     <!-- Modal find opportunity -->
     <modal name="modalinputPhone" :resizable="true" height="auto" width="60%">

       
        <div class="row justify-content-start my-1 px-4 pt-3"> 
            <div class="col-12 col-md-5">
              <input v-model="phoneOpportunity" type="text" class="form-control" :disabled="searching" placeholder="Type any phone number...">
            </div>
            <div class="col-12 col-md-5 px-0"> 
              <button class="btn btn-primary py-1" @click="getOpprtunityByPhone" :disabled="searching">Find opportunity</button>
              <button class="btn btn-light ml-2 py-1" @click="clearOpprtunityByPhone" :disabled="searching">Clear</button>          
            

              <span v-if="searching" class="ml-2">
                <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
              </span>

            </div>           
          </div>     
          <div class="row ml-3 p-0" v-if="showErrorValidPhone">
            <div class="col-12 ml-3 p-0 text-danger">
              <small>{{  $t("lang.label.phone_invalid") }}</small>
            </div>
          </div>      

          <div class="row justify-content-start my-1 px-4 py-1"> 
          <template v-if="list.length > 0">
          <div class="mt-4 mx-0 px-0 table-responsive">
              <Table
              :headers="header"
              :cols="cols"
              :data="list"
              :checkbox="false" 
              :notselect="true"                         
              :key="key"  
              @goToOpportunity="goToOpportunity"
              >
              </Table>
          
          </div>
        </template>
          <!-- <div class="col-12">
            No data
          </div> -->
        </div>        
      </modal>
          <button v-if="isMobile && !hideSidebar" class="navbar-toggler w-100 mt-3  bg-primary" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" ref="toggleMenu">
            <span class="icon-more_horiz text-white"></span>
          </button>
  </section>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { router } from '@/_helpers';
import { clientsService, captainDataService } from '@/_services';
import Tooltip from "@/components/Common/Tooltip.vue";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import BookerStatsIcons from "@/components/BDR/BookerStatsIcons.vue";
import { opportunitiesService } from "../_services/opportunities.service";
import Table from "@/components/Common/Table.vue";

export default {
  data() {
    return {
      showErrorValidPhone: false,
      key: 122,
      searching: false,
      list:[],
      phoneOpportunity: null,
      userSubscription: "-1",
      bdrMeetingsRateThreshold: 3,
      bdrInfo: {},
      loadingData: false,
      paramloading: {
        width: '18px',
        height: '18px',
        color: '#5054EB'
      },
      paramloadingMed: {
        width: '38px',
        height: '38px',
        color: '#5054EB'
      },
      pageToForward: 0,
      current_captaindata_uid: false,
      isRouteSteps: false,
      contactsLeft: 0,
      daysLeft: 0,
      errormessage: false,
      syncronizing: true,
      cookie: false,
      mycaptainusers: [],
      header: [
          {
            label: "Opportunity",
            class: "overflowhide",
          },
          {
            label: "Contact name",
            class: "overflowhide",
          },
          {
            label: "Contact phone",
            class: "overflowhide",
          },
          {
            label: "Last task",
            class: "overflowhide",
          },
          {
            label: "Booker",
            class: "overflowhide",
          }          
        ],
      cols: [
          [
            {
              value_label: "business_name",
              value_emit: "link_id",
              class: "text-primary",
              type: "emit",
              emit: "goToOpportunity",
            },
          ],
          [
            {
            value: "contact_name",
            class: "text-primary",
            },
          ],
          [
            {
            value: "phone",
            class: "text-primary",
            },
          ],
          [
            {
              value: "last_update",
            },
          ],
          [
            {
              value: "booker",
            },
          ],
         
        ],
    };
  },
  components: {
    Tooltip,
    Loadingcircle,
    BookerStatsIcons,
    Table,
  },
  props: {
    info: {
      type: String,
      default: null
    },
    hideSidebar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      loadingStats: state => state.campaigns.loadingStats,
      loadingStatsComplete: state => state.campaigns.loadingStatsComplete,
      stats: state => state.campaigns.stats.data,
      statsHeaderBar: state => state.campaigns.statsHeaderBar.data,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      stack: state => state.headertopbar.stackPages,
      pagestofwd: state => state.headertopbar.nextPages,
      getCurrentRoute: state => state.headertopbar.page,
      getCurrentRouteLabel: state => state.headertopbar.pageLabel,
      getChild: state => state.headertopbar.child,
      myCampaigns: state => state.campaigns.all.data,
      currentUser: (state) => state.authentication.user
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    isDisableBack() {
      return this.stack > 2 ? false : true;
    },
    isDisableForward() {
      return this.pagestofwd > 0 ? false : true;
    },
    routeSteps() {
      return (this.$route.path.includes('/campaigns/') && this.$route.path.includes('/step')) ? true : false;
    },
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
    isUserOperational() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 1);
    },
    isBdrUser() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2)
    },
    showBDRSuspensionAlert() {
      return false;
      return (this.bdrInfo.user_bdr_status_id == 4 && this.bdrInfo.days_since_status_change > 40) || ['5', '6'].includes(this.bdrInfo.user_bdr_status_id);
    },
    isSubscriptionConnectPlusActive() {
      return this.currentUser.plan_id == 5 && this.currentUser.subscription_status_id == 1 && this.currentUser.subscription_free == 0
    },
  },

  watch: {
    info(newVal) {
      if (newVal) {
        //console.log(newVal)
      }
    }
  },

  mounted() {
    // console.log(this.props)
    this.$root.$on('removecaptain', arg => {
      this.current_captaindata_uid = false
      this.currentUser.synUser.is_valid = false
    })
  },

  created() {
    this.sp();
    this.getAllOptionsList;
    this.getDataStats();
    //if(this.permissionFront() && this.currentUser.role_id == 1){
    //    this.syncronize();
    //    this.getCaptainDataUsers();
    //}
  },

  methods: {
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRangeToHeaderBar"
    }),
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setStack: 'setStackPages',
      pagesFwdInc: "increment",
      pagesFwdDec: "decrement",
      setCurrentRoute: "setRoute",
      currentRoute: "changePage",
    },
      "optionsList", {
      getAllOptionsList: "getAll",
    }
    ),
    goToOpportunity(link_id) {
        window.open("/opportunities/" + link_id, "_blank");
    },
    clearOpprtunityByPhone() {
      this.list = []
      this.phoneOpportunity = null
    },
    validPhone() {
      const regex = /^\d{10,}$/
      return regex.test(this.phoneOpportunity);
    }, 
    getOpprtunityByPhone(){
      this.showErrorValidPhone = false
      if(!this.validPhone()){
        this.showErrorValidPhone = true
        return
      }
      this.list = []
      this.searching = true

      const encodedPhone = encodeURIComponent(this.phoneOpportunity);
      opportunitiesService.getOpprtunityByPhone(encodedPhone)
        .then(result => {

          this.list = result.result.map( el => {
            const contact_name = (el.first_name + " " + el.last_name).trim()
            const booker = (el.booker_name + " " + el.booker_lastname).trim()
            return {
              ...el,
              contact_name,
              booker
            }
          })

          this.searching = false
        })
    },
    searchOpportunity(){
      this.list = []
      this.phoneOpportunity = null
      this.$modal.show('modalinputPhone');
    },
    goToUpgrade(){
      this.$router.push('/upgrade'); 
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getDataStats() {
      this.loadingData = true;
      this.getCampaignStatsByIdAndRange({
        id: 0,
        startDate: "",
        endDate: "",
        client: false,
        toHeaderTopBar: true,
        filters: [
          "money",
          "sent",
          "meetings",
          "conversion_rate"
        ]
      });
    },
    hasLimit(limits) {
      if (limits[0].item_scraped == limits[0].limit_value) {
        return true;
      }
      if (limits[3].item_scraped == limits[3].limit_value) {
        return true;
      }
      return false;
    },
    getCaptainDataUsers() {
      captainDataService.getUsers().then(result => {
        this.mycaptainusers = result.result
      })
    },
    permissionFront() {
      return (this.currentUser.team_role_id == undefined || this.currentUser.team_role_id != 3)
    },
    hasError() {
      if
        (
        (this.currentUser.synUser !== undefined && this.currentUser.synUser && !this.currentUser.synUser.is_valid) ||
        (this.errormessage && this.currentUser.synUser === undefined)
      ) {
        return true;

      } else {
        return false;
      }
    },
    switchCaptaindata() {
      if (this.current_captaindata_uid) {
        captainDataService.getUserByCaptainUid(this.current_captaindata_uid).then((response) => {
          if (response.result.name !== undefined) {
            this.currentUser.synUser = response.result
            this.current_captaindata_uid = this.currentUser.synUser.uid
            this.errormessage = false
            if (this.currentUser.synUser !== undefined && this.currentUser.synUser.is_valid == false) {
              this.errormessage = this.$t('lang.ondemand.errormes')
            }
            this.$root.$emit('switchcaptaindata')
          } else {
            this.errormessage = this.$t('lang.ondemand.errormes')

          }
          this.syncronizing = false
          this.cookie = true
        })
      }
    },
    syncronize() {

      let cookie = captainDataService.getLinkedinCookie();
      captainDataService.getUser(cookie).then((response) => {
        if (response.result !== null && response.result.name !== undefined) {
          this.currentUser.synUser = response.result
          this.current_captaindata_uid = this.currentUser.synUser.uid
          this.errormessage = false
          if (this.currentUser.synUser !== undefined && this.currentUser.synUser.is_valid == false) {
            this.errormessage = this.$t('lang.ondemand.errormes')
          }
        } else {
          this.errormessage = this.$t('lang.ondemand.errormes')

        }
        this.syncronizing = false
        this.cookie = true
      })

    },
    getClassTrial() {
      if (this.myCampaigns !== undefined) {
        var total = this.contactsLeft
        if (total < 10)
          return "bg-danger"
        if (total < 50)
          return "bg-warning"
      }
      return "bg-success"

    },
    ...mapMutations('sidebar', {
      NavigationClicked: 'navigationClicked'
    }),
    initSetRoute() {
      this.$route.fullPath == '/businesses' ? this.setCurrentRoute({ page: 'contacts' }) : this.setCurrentRoute({ page: this.$route.name })
    },
    sp() {
      this.setStack({ cantPages: window.history.length });
    },
    back() {
      this.changeHeaderTab({ tab: "ALL" });
      this.pagesFwdInc();
      return router.go(-1);
    },
    forward() {
      this.pagesFwdDec();
      return router.go(1);
    },
    forwardTwo() {
      this.pagesFwdDec();
      return router.go(2);
    },
    resetForward() {
      this.pageToForward = 0;
    },
    backAllCamp() {

    },
    setBdrInfo(bdrInfo) {
      this.bdrInfo = bdrInfo;
      console.log({ bdrInfo })
    },

    getBdrInfoValue(key) {
      return 1;
      // return this.bdrInfo.find(el => el.id == key).value
    },

    mousedown(routeTo) {

    
      if (this.$route.path.includes(routeTo)) {
        this.NavigationClicked();
        this.$router.push({
          path: routeTo,
        });
      }  

      if (this.isMobile) {
        this.$refs.toggleMenu.click();
      }

    },


  }
}
</script>
<style scoped>
  .left0{
  left:0;
  }

#header-top-bar {
  background-color: #FFFFFF;
  padding-top: .8em;
  padding-bottom: .8em;
  padding-right: 1em;
  padding-left: 1em;

  .img-user {
    width: 35px;
    height: 35px;
  }

  .vl {
    border-left: 1px solid grey;
    height: 50px;
  }

  .items {
    width: 300px;

    [class^="icon-"],
    [class*=" icon-"] {
      font-size: 20px;
    }
  }

  .nav {
    color: #000000;

    &.active {
      color: #000000;
    }
  }

  .btncontacts {
    border-radius: 5px;
    border: 1px solid;
    border-color: #c5c5f8;
  }

  .btnheader {
    border: none;
    outline: none;
    background: transparent;

    &.disabled {
      .nav {
        color: #c7c4c4;
      }
    }
  }

  .nameuser {
    font-weight: 600;
  }

  .wrapper-header {
    margin-left: 250px;

    &.expand {
      margin-left: 60px;
    }
  }
}

@media(max-width:992px) {
  #header-top-bar {
    .wrapper-header {

      margin-left: 0px !important;
    }

    .items {
      width: 100%;
    }
  }
}

@media(max-width:480px) {
  #header-top-bar {
    padding-top: 10px;
  }
}
</style>
